import Splide, { Options } from "@splidejs/splide";

/* Interfaces */
interface IAriaTranslations {
  prev: string;
  next: string;
  first: string;
  last: string;
  slideX: string;
  carousel: string;
  select: string;
  slide: string;
  slideLabel: string;
}

export default class PlaySection {
  readonly playSections: NodeListOf<HTMLElement>;
  readonly playSectionCarouselOptions: Options;
  private ariaTranslations: IAriaTranslations | undefined = undefined;

  constructor() {
    this.playSections = document.querySelectorAll('.play-section-block');
    this.playSectionCarouselOptions = {
      type: 'loop',
      speed: 500,
      width: '100%',
      fixedWidth: '295px',
      clones: 0,
      start: 0,
      focus: 0,
      perMove: 1,
      easing: 'ease',
      drag: true,
      flickPower: 150,
      flickMaxPages: 1,
      arrowPath: 'M9.76407 0.764069C10.7828 -0.25469 12.4346 -0.25469 13.4533 0.764069L30.8446 18.1554C31.3339 18.6446 31.6087 19.3081 31.6087 20C31.6087 20.6919 31.3339 21.3554 30.8446 21.8446L13.4533 39.2359C12.4346 40.2547 10.7828 40.2547 9.76407 39.2359C8.74531 38.2172 8.74531 36.5654 9.76407 35.5467L25.3107 20L9.76407 4.45332C8.74531 3.43456 8.74531 1.78283 9.76407 0.764069Z',
      keyboard: true,
      updateOnMove: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        0: {
          fixedWidth: '90%',
        },
        768: {
          fixedWidth: '488px',
        },
        992: {
          fixedWidth: '563px',
        }
      },
      mediaQuery: 'min',
      classes: {
        arrow: 'play-section-block__arrow splide__arrow',
        prev: 'play-section-block__arrow--prev splide__arrow--prev ',
        next: 'play-section-block__arrow--next splide__arrow--next '
      }
    }

    this.init();
  }

  private init(): void {
    if (this.playSections.length > 0) {
      this.playSections.forEach(playSection => {
        this.setUpCarousel(playSection);
      });
    }
  }

  private setUpCarousel(playSection: HTMLElement): void {
    const carouselSection = playSection.querySelector(".play-section-block__carousel") as HTMLElement;

    if (!this.ariaTranslations) {
      this.setAriaTranslations(carouselSection);
      this.playSectionCarouselOptions.i18n = this.ariaTranslations;
    }

    const carouselId: string = carouselSection.id;
    const carousel: Splide = new Splide(`#${carouselId}`, this.playSectionCarouselOptions);

    carousel.mount();

    // Go to the previous slide
    playSection.querySelectorAll('button.play-section-block__arrow--prev')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('<');
      });
    });

    // Go to the next slide
    playSection.querySelectorAll('.play-section-block__arrow--next')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('>');
      });
    });
  }

  private setAriaTranslations(carousel: HTMLElement): void {
    let ariaTranslationsString = carousel.dataset.ariaText as string;
    let ariaTranslationsArray = ariaTranslationsString.split(', ') as string[];

    let ariaTranslationsObject: IAriaTranslations = {
      prev: ariaTranslationsArray[0],
      next: ariaTranslationsArray[1],
      first: ariaTranslationsArray[2],
      last: ariaTranslationsArray[3],
      slideX: ariaTranslationsArray[4],
      carousel: ariaTranslationsArray[5],
      select: ariaTranslationsArray[6],
      slide: ariaTranslationsArray[7],
      slideLabel: ariaTranslationsArray[8]
    }

    this.ariaTranslations = ariaTranslationsObject;
  }
}

document.addEventListener('DOMContentLoaded', (): void => {
  new PlaySection();
});
